import { render } from "./FooTer.vue?vue&type=template&id=da24bbe2"
const script = {}

import "./FooTer.vue?vue&type=style&index=0&id=da24bbe2&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__